var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7669 4.625C19.4323 4.625 19.16 4.89731 19.16 5.23193C19.16 5.56655 19.4323 5.83887 19.7669 5.83887C20.1016 5.83887 20.3739 5.5666 20.3739 5.23193C20.3739 4.89727 20.1016 4.625 19.7669 4.625ZM12.4998 7.11841C9.53291 7.11841 7.11914 9.53218 7.11914 12.4991C7.11914 15.466 9.53291 17.8798 12.4998 17.8798C15.4667 17.8798 17.8805 15.466 17.8805 12.4991C17.8805 9.53223 15.4667 7.11841 12.4998 7.11841Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1466 0H6.85337C3.07441 0 0 3.07441 0 6.85342V18.1466C0 21.9256 3.07441 25 6.85337 25H18.1466C21.9256 25 25 21.9256 25 18.1466V6.85342C25 3.07441 21.9256 0 18.1466 0ZM12.5 19.357C8.71899 19.357 5.64302 16.281 5.64302 12.5C5.64302 8.71899 8.71904 5.64307 12.5 5.64307C16.281 5.64307 19.357 8.71904 19.357 12.5C19.357 16.281 16.281 19.357 12.5 19.357ZM19.7671 7.31621C18.6184 7.31621 17.6838 6.38164 17.6838 5.23291C17.6838 4.08418 18.6184 3.14956 19.7671 3.14956C20.9159 3.14956 21.8504 4.08413 21.8504 5.23286C21.8504 6.38159 20.9159 7.31621 19.7671 7.31621Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c43e64ce422fc87c12bf0182c1b5d3cd.svg";
export { ForwardRef as ReactComponent };